@if (targetTimestamp()) {
  @if (variant() === 'banner') {
    <div [class]="containerClasses()">
      <div class="flex items-center gap-2.5 min-w-0">
        @if (showIcon()) {
          <mat-icon class="text-lg! shrink-0 leading-none">{{ iconName() }}</mat-icon>
        }
        <div class="flex flex-col min-w-0">
          @if (prefix()) {
            <span class="text-xs opacity-85 leading-snug">{{ prefix() }}</span>
          }
          <span class="text-sm font-bold tabular-nums tracking-tight">{{ formattedTime() }}</span>
        </div>
      </div>

      @if (showProgress()) {
        <div
          class="w-24 sm:w-32 bg-black/10 dark:bg-white/10 rounded-full h-1.5 overflow-hidden ml-3 shrink-0"
        >
          <div
            class="h-full rounded-full transition-all duration-500 ease-out"
            [class]="
              urgency() === 'critical'
                ? 'bg-tomato-9'
                : urgency() === 'warning'
                  ? 'bg-amber-9'
                  : urgency() === 'expired'
                    ? 'bg-neutral-8'
                    : 'bg-primary-9'
            "
            [style.width.%]="progressPercent()"
          ></div>
        </div>
      }
    </div>
  } @else {
    <span [class]="containerClasses()">
      @if (showIcon()) {
        <mat-icon
          class="shrink-0 leading-none"
          [class]="size() === 'xs' ? 'text-xs!' : size() === 'md' ? 'text-base!' : 'text-sm!'"
          >{{ iconName() }}</mat-icon
        >
      }
      @if (prefix()) {
        <span class="opacity-85 font-normal">{{ prefix() }}</span>
      }
      <span class="tabular-nums tracking-tight font-bold">{{ formattedTime() }}</span>

      @if (showProgress()) {
        <span
          class="w-12 bg-black/10 dark:bg-white/10 rounded-full h-1 overflow-hidden ml-1 shrink-0 inline-block"
        >
          <span
            class="block h-full rounded-full transition-all duration-500 ease-out"
            [class]="
              urgency() === 'critical'
                ? 'bg-tomato-9'
                : urgency() === 'warning'
                  ? 'bg-amber-9'
                  : urgency() === 'expired'
                    ? 'bg-neutral-8'
                    : 'bg-primary-9'
            "
            [style.width.%]="progressPercent()"
          ></span>
        </span>
      }
    </span>
  }
}
